/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    SET_FETCH_FACILITY_IMAGES_STATUS,
    FETCH_FACILITY_IMAGES_SUCCESS,
    FETCH_FACILITY_IMAGES_ERROR,
} from '../actions/facilityImagesActions';

export const initialState = {
    loadingStatus: STATUS.IDLE,
    isLoading: true,
};

export const facilityImagesReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_FACILITY_IMAGES_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_FACILITY_IMAGES_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
            };
        }

        case FETCH_FACILITY_IMAGES_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        default:
            return state;
    }
};
